<!-- Desktop Version -->
<div class="relative hidden w-full pb-16 md:block" role="group" [attr.aria-label]="'Postęp składania zamówienia' | translate">
  <div class="relative mx-auto flex w-full max-w-5xl items-center justify-between">
    <div
      class="absolute left-5 right-5 top-1/2 h-0.5 -translate-y-1/2 rounded-full bg-gray-200"
      role="progressbar"
      [attr.aria-valuemin]="1"
      [attr.aria-valuemax]="steps.length"
      [attr.aria-valuenow]="normalizedCurrentStep"
      [attr.aria-valuetext]="'Krok ' + normalizedCurrentStep + ' z ' + steps.length + ': ' + currentStepName">
      <div class="h-full rounded-full bg-brocom-orange transition-[width] duration-300 ease-out"
        [style.width.%]="progressPercent"></div>
    </div>
    <ng-container *ngFor="let item of steps; let i = index">
      <div
        class="checkout-step-marker relative z-10 grid h-10 w-10 place-items-center rounded-full font-bold transition-colors duration-300"
        [ngClass]="{
          'bg-brocom-orange text-white shadow-sm': normalizedCurrentStep === i + 1,
          'bg-orange-100 text-brocom-orange': normalizedCurrentStep > i + 1,
          'bg-gray-100 text-gray-500': normalizedCurrentStep < i + 1
        }"
        aria-hidden="true">
        <span class="checkout-step-marker-number">{{ i + 1 }}</span>
        <span
          class="absolute left-1/2 top-full mt-5 w-max max-w-40 -translate-x-1/2 text-center text-xs font-semibold leading-4 transition-colors"
          [ngClass]="{
            'text-brocom-orange': normalizedCurrentStep === i + 1,
            'text-gray-600': normalizedCurrentStep > i + 1,
            'text-gray-400': normalizedCurrentStep < i + 1
          }">
          {{ item.name }}
        </span>
      </div>
    </ng-container>
  </div>
</div>

<!-- Mobile Version -->
<div class="md:hidden" role="group" [attr.aria-label]="'Postęp składania zamówienia' | translate">
  <div class="flex items-center justify-between mb-4">
    <div class="text-sm text-gray-600">
      {{ 'Krok' | translate }} <span class="font-semibold text-brocom-orange">{{ normalizedCurrentStep }}</span> {{ 'z' | translate }} {{ steps.length }}
    </div>
    <div class="text-sm font-medium text-gray-800">
      {{ currentStepName }}
    </div>
  </div>

  <div class="h-1.5 w-full overflow-hidden rounded-full bg-gray-200"
    role="progressbar"
    [attr.aria-valuemin]="1"
    [attr.aria-valuemax]="steps.length"
    [attr.aria-valuenow]="normalizedCurrentStep"
    [attr.aria-valuetext]="'Krok ' + normalizedCurrentStep + ' z ' + steps.length + ': ' + currentStepName">
    <div class="h-full rounded-full bg-brocom-orange transition-[width] duration-300 ease-out"
      [style.width.%]="progressPercent"></div>
  </div>

  <div class="mt-3 flex justify-center gap-2" aria-hidden="true">
    <span *ngFor="let step of steps; let i = index"
      class="h-1.5 rounded-full transition-all duration-300"
      [class.w-5]="i + 1 === normalizedCurrentStep"
      [class.w-1.5]="i + 1 !== normalizedCurrentStep"
      [class.bg-brocom-orange]="i + 1 <= normalizedCurrentStep"
      [class.bg-gray-300]="i + 1 > normalizedCurrentStep"></span>
  </div>
</div>